/*
 * @Author: 大侠传授两招吧
 * @Date: 2022-03-19 23:41:35
 * @LastEditors: 大侠传授两招吧
 * @LastEditTime: 2022-03-29 19:02:27
 * @Description: 
 */
export default{//定义一个基础数据
    userInfo:{},
    message: '',
    notices: [],
    downloadImg:{},//下载app二维码
    socket: null,
    socketUrl:'', // url动态获取 默认测试环境
    socketMsg: '',
    imgFolder: 'img',
    imagesFolder: 'images',
    infofold: '0', // 游客进入消息是否折叠
    visitor_chat: '0',   // 游客是否能发言
    config: {},
    giftList: [],
    sportType: [],
    room_service_url: '' // 直播间单独的客服链接
}


// WEBPACK FOOTER //
// ./src/store/state.js